var _path, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgJourneyLeftSingle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 171,
    height: 314,
    viewBox: "0 0 171 314",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M0 160H170",
    stroke: "url(#paint0_linear_103_9503)",
    strokeOpacity: 0.64,
    strokeWidth: 12
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_103_9503",
    x1: 4.34043,
    y1: 160,
    x2: 166.021,
    y2: 160,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00C19F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0064C1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_103_9503",
    x1: 0,
    y1: 6,
    x2: 171,
    y2: 160,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00C19F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0064C1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_103_9503",
    x1: -0.00000363183,
    y1: 310.5,
    x2: 171,
    y2: 160,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00C19F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0064C1"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgJourneyLeftSingle);
export default __webpack_public_path__ + "97131/static/media/journey-left-single.31e20d8157d0802859af27dfb3a4daf7.svg";
export { ForwardRef as ReactComponent };